/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PortalAccountStatusResponse,
  ProblemDetails,
} from '../models/index';
import {
    PortalAccountStatusResponseFromJSON,
    PortalAccountStatusResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface GetVolunteerPortalAccountStatusRequest {
    volunteerId: string;
}

export interface LockVolunteerPortalAccountRequest {
    volunteerId: string;
}

export interface ResendVolunteerPortalInvitationRequest {
    volunteerId: string;
}

export interface SendVolunteerPortalInvitationRequest {
    volunteerId: string;
}

export interface SendVolunteerPortalPasswordResetRequest {
    volunteerId: string;
}

export interface UnlockVolunteerPortalAccountRequest {
    volunteerId: string;
}

/**
 * VolunteerPortalAccountsApi - interface
 * 
 * @export
 * @interface VolunteerPortalAccountsApiInterface
 */
export interface VolunteerPortalAccountsApiInterface {
    /**
     * 
     * @param {string} volunteerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteerPortalAccountsApiInterface
     */
    getVolunteerPortalAccountStatusRaw(requestParameters: GetVolunteerPortalAccountStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalAccountStatusResponse>>;

    /**
     */
    getVolunteerPortalAccountStatus(requestParameters: GetVolunteerPortalAccountStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalAccountStatusResponse>;

    /**
     * 
     * @param {string} volunteerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteerPortalAccountsApiInterface
     */
    lockVolunteerPortalAccountRaw(requestParameters: LockVolunteerPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    lockVolunteerPortalAccount(requestParameters: LockVolunteerPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} volunteerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteerPortalAccountsApiInterface
     */
    resendVolunteerPortalInvitationRaw(requestParameters: ResendVolunteerPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    resendVolunteerPortalInvitation(requestParameters: ResendVolunteerPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} volunteerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteerPortalAccountsApiInterface
     */
    sendVolunteerPortalInvitationRaw(requestParameters: SendVolunteerPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    sendVolunteerPortalInvitation(requestParameters: SendVolunteerPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} volunteerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteerPortalAccountsApiInterface
     */
    sendVolunteerPortalPasswordResetRaw(requestParameters: SendVolunteerPortalPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    sendVolunteerPortalPasswordReset(requestParameters: SendVolunteerPortalPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} volunteerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VolunteerPortalAccountsApiInterface
     */
    unlockVolunteerPortalAccountRaw(requestParameters: UnlockVolunteerPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    unlockVolunteerPortalAccount(requestParameters: UnlockVolunteerPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class VolunteerPortalAccountsApi extends runtime.BaseAPI implements VolunteerPortalAccountsApiInterface {

    /**
     */
    async getVolunteerPortalAccountStatusRaw(requestParameters: GetVolunteerPortalAccountStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortalAccountStatusResponse>> {
        if (requestParameters['volunteerId'] == null) {
            throw new runtime.RequiredError(
                'volunteerId',
                'Required parameter "volunteerId" was null or undefined when calling getVolunteerPortalAccountStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers/{volunteerId}/portal-account`;
        urlPath = urlPath.replace(`{${"volunteerId"}}`, encodeURIComponent(String(requestParameters['volunteerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortalAccountStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getVolunteerPortalAccountStatus(requestParameters: GetVolunteerPortalAccountStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortalAccountStatusResponse> {
        const response = await this.getVolunteerPortalAccountStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async lockVolunteerPortalAccountRaw(requestParameters: LockVolunteerPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['volunteerId'] == null) {
            throw new runtime.RequiredError(
                'volunteerId',
                'Required parameter "volunteerId" was null or undefined when calling lockVolunteerPortalAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers/{volunteerId}/portal-account/lock`;
        urlPath = urlPath.replace(`{${"volunteerId"}}`, encodeURIComponent(String(requestParameters['volunteerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async lockVolunteerPortalAccount(requestParameters: LockVolunteerPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.lockVolunteerPortalAccountRaw(requestParameters, initOverrides);
    }

    /**
     */
    async resendVolunteerPortalInvitationRaw(requestParameters: ResendVolunteerPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['volunteerId'] == null) {
            throw new runtime.RequiredError(
                'volunteerId',
                'Required parameter "volunteerId" was null or undefined when calling resendVolunteerPortalInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers/{volunteerId}/portal-account/invitation/resend`;
        urlPath = urlPath.replace(`{${"volunteerId"}}`, encodeURIComponent(String(requestParameters['volunteerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async resendVolunteerPortalInvitation(requestParameters: ResendVolunteerPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resendVolunteerPortalInvitationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async sendVolunteerPortalInvitationRaw(requestParameters: SendVolunteerPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['volunteerId'] == null) {
            throw new runtime.RequiredError(
                'volunteerId',
                'Required parameter "volunteerId" was null or undefined when calling sendVolunteerPortalInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers/{volunteerId}/portal-account/invitation`;
        urlPath = urlPath.replace(`{${"volunteerId"}}`, encodeURIComponent(String(requestParameters['volunteerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendVolunteerPortalInvitation(requestParameters: SendVolunteerPortalInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendVolunteerPortalInvitationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async sendVolunteerPortalPasswordResetRaw(requestParameters: SendVolunteerPortalPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['volunteerId'] == null) {
            throw new runtime.RequiredError(
                'volunteerId',
                'Required parameter "volunteerId" was null or undefined when calling sendVolunteerPortalPasswordReset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers/{volunteerId}/portal-account/password-reset`;
        urlPath = urlPath.replace(`{${"volunteerId"}}`, encodeURIComponent(String(requestParameters['volunteerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async sendVolunteerPortalPasswordReset(requestParameters: SendVolunteerPortalPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendVolunteerPortalPasswordResetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async unlockVolunteerPortalAccountRaw(requestParameters: UnlockVolunteerPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['volunteerId'] == null) {
            throw new runtime.RequiredError(
                'volunteerId',
                'Required parameter "volunteerId" was null or undefined when calling unlockVolunteerPortalAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/volunteers/{volunteerId}/portal-account/unlock`;
        urlPath = urlPath.replace(`{${"volunteerId"}}`, encodeURIComponent(String(requestParameters['volunteerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async unlockVolunteerPortalAccount(requestParameters: UnlockVolunteerPortalAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlockVolunteerPortalAccountRaw(requestParameters, initOverrides);
    }

}
